import $http from "@/core/services/http.service";
import { ActionTree } from "vuex";

import { State } from "@/clickbuy/purchase/store/state";
import Endpoints from "@/constants/endpoints";

import UtilsService from "@/core/services/utils.service";
import { Purchase } from "@/clickbuy/purchase/models/purchase.model";

import Constants from "@/constants/constants";

export interface Actions {
  fetchPurchaseList: {};
}

export const actions: ActionTree<State, any> = {
  setPurchaseListStore: ({ commit }, payload) => {
    commit("setPurchaseList", payload);
  },

  newPurchase: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.purchase}`, payload.newPurchase)
        .then(res => {
          const data = res.data;
          commit("setPurchaseList", [data]);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  patchPurchase: ({ commit, getters }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(`${Endpoints.purchase}${payload.id}/`, payload.data)
        .then(res => {
          const data = res.data;
          commit("updatePurchase", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  updatePurchase: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(`${Endpoints.purchase}${payload.id}/`, payload)
        .then(res => {
          const data = res.data;
          commit("updatePurchase", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchInternalBusiness: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let params: any = {};
      params = UtilsService.getQueryParams(payload);
      $http
        .get(`${Endpoints.internalBusiness}`, { params })
        .then(res => {
          resolve(res.data.results);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  annullatePurchase: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(`${Endpoints.purchase}${payload.id}/`, { purchaseStatus: payload.purchaseStatus })
        .then(() => {
          resolve(payload.id);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  deletePurchase: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .delete(`${Endpoints.purchase}${payload.id}/`)
        .then(() => {
          commit("removePurchase", payload.id);
          resolve(payload.id);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newPurchaseNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.purchase}${payload.purchaseId}/note`, {
          employee: payload.employee,
          note: payload.note,
          mentions: payload.mentions
        })
        .then(res => {
          const data = res.data;
          commit("newPurchaseNote", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newBudget: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.budget}`, payload)
        .then(res => {
          const data = res.data;
          commit("newBudget", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  updateBudget: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(`${Endpoints.budget}${payload.id}/`, payload)
        .then(res => {
          const data = res.data;
          commit("updateBudget", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  updateStoreBudget: ({ commit }, payload) => {
    commit("updateBudget", payload);
  },
  updateStoreBudgetFee: ({ commit }, payload) => {
    commit("updateBudgetFee", payload);
    commit("updateBudget", payload.budget);
  },
  deleteBudget: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .delete(`${Endpoints.budget}${payload.id}/`)
        .then(() => {
          commit("removeBudget", payload.id);
          resolve(payload.id);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchPurchase: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.purchase}${payload.id}/`)
        .then(res => {
          const data = res.data;
          commit("setPurchaseList", [data]);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchPurchaseList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let params: any = {};

      params = UtilsService.getQueryParams(payload);

      if (payload.filter) {
        const filter = payload.filter;
        for (const key in filter) {
          if (filter.hasOwnProperty(key)) {
            const value = filter[key];
            if (value && key !== 'total') {
              params = Object.assign({}, params, { [key]: value });
            }
          }
        }
      }

      $http
        .get(`${Endpoints.purchaseConvocation}${payload.id}/`, { params })
        .then(res => {
          const data = res.data;
          commit("setPurchaseList", data.results);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchPurchaseListCounters: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.purchaseConvocationCounters}${payload.id}/`, {})
        .then(res => {
          const data = res.data;
          // commit("setPurchaseList", data.results);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  
  fetchBudget: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.budget}${payload.id}/`)
        .then(res => {
          const data = res.data;
          commit("updateBudget", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchBudgetList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let params: any = {};
      params = UtilsService.getQueryParams(payload);
      $http
        .get(`${Endpoints.budget}`, { params })
        .then(res => {
          const data = res.data;
          commit("setBudgetList", data.results);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  generateFees: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      let params: any = {};
      params = UtilsService.getQueryParams(payload);
      $http
        .post(`${Endpoints.budget}${payload.id}/budgetfee/`, null, { params })
        .then(res => {
          const data = res.data;
          commit("setBudgetFees", {
            budgetId: payload.id,
            fees: data.budgetFee
          });
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  patchBudget: ({ commit, getters }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(`${Endpoints.budget}${payload.id}/`, payload.data)
        .then(res => {
          const data = res.data;
          commit("updateBudget", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  setPurchaseList: ({ commit }, payload) => {
    commit("setPurchaseList", payload);
  },
  fetchSaleInfo: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.convocation}${payload.id}/sale-info/`)
        .then(res => {
          const data = res.data;
          commit("setSaleInfo", data.results);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchCompanion: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.companion}${payload.id}/`)
        .then(res => {
          const data = res.data;
          commit("setCompanionList", [data]);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchBudgetNotes: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.budget}${payload.id}/note`)
        .then(res => {
          const data = res.data.results;
          commit("setBudgetNotes", { budgetId: payload.id, notes: data });
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchPurchaseNotes: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.purchase}${payload.id}/note`)
        .then(res => {
          const data = res.data.results;
          commit("setPurchaseNotes", { purchaseId: payload.id, notes: data });
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchBudgetProducts: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.budget}${payload.id}/product/`)
        .then(res => {
          const data = res.data.results;
          commit("setCurrentBudgetAcceptanceProductList", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchBudgetProductsPack: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.budget}${payload.id}/product/pack`)
        .then(res => {
          const data = res.data.results;
          commit("setCurrentBudgetAcceptanceProductPackList", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newBudgetNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.budget}${payload.budgetId}/note`, {
          employee: payload.employee,
          note: payload.note,
          mentions: payload.mentions
        })
        .then(res => {
          const data = res.data;
          commit("newBudgetNote", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newBudgetCommentNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.budget}${payload.elementId}/note/${payload.noteId}/comment`, {
          employee: payload.employee,
          comment: payload.comment
        })
        .then(res => {
          const data = res.data;
          commit("newBudgetCommentNote", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  patchBudgetNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(
          `${Endpoints.budget}${payload.budgetId}/note/${payload.noteId}/`,
          payload.data
        )
        .then(res => {
          commit("updateParticipantNote", res.data);
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  patchPurchaseNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(
          `${Endpoints.purchase}${payload.purchaseId}/note/${payload.noteId}/`,
          payload.data
        )
        .then(res => {
          commit("updateParticipantNote", res.data);
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  removePurchaseNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .delete(`${Endpoints.purchase}${payload.id}/note/${payload.noteId}/`)
        .then(() => {
          commit("removePurchaseNote", payload.noteId);
          resolve(payload.noteId);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  patchBudgetCommentNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(
          `${Endpoints.budget}${payload.elementId}/note/${payload.noteId}/comment/${payload.commentId}`,
          payload.data
        )
        .then(res => {
          commit("updateParticipantCommentNote", res.data);
          resolve(res.data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  removeBudgetNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .delete(`${Endpoints.budget}${payload.id}/note/${payload.noteId}/`)
        .then(() => {
          commit("removeBudgetNote", payload.noteId);
          resolve(payload.noteId);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  removeBudgetCommentNote: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .delete(`${Endpoints.budget}${payload.elementId}/note/${payload.noteId}/comment/${payload.commentId}`)
        .then(() => {
          commit("removeBudgetCommentNote", payload.noteId);
          resolve(payload.noteId);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  updateCompanion: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(`${Endpoints.companion}${payload.id}/`, payload)
        .then(res => {
          const data = res.data;
          commit("updateCompanion", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newCurrentPurchase: ({ commit }) => {
    const newPurchase = new Purchase();
    newPurchase.purchaseLines = [];
    newPurchase.totalPrice = 0;
    newPurchase.totalPriceWithoutTax = 0;
    newPurchase.reserveAmount = 0;
    newPurchase.totalPaymentPending = 0;
    commit("setCurrentPurchase", newPurchase);
  },
  updateCurrentPurchase: ({ commit, getters }, payload) => {
    payload.reserveAmount = getters.getCurrentPurchaseReserveAmount;
    payload.totalPriceWithoutTax =
      getters.getCurrentPurchaseTotalPriceWithoutTax;
    payload.totalPrice = getters.getCurrentPurchaseTotalPrice;
    payload.totalPaymentPending = getters.getCurrentPurchasePaymentPending;
    payload.soonPaymentDiscount = getters.getCurrentPurchaseSoonPaymentDiscount;
    commit("setCurrentPurchase", payload);
  },
  setCurrentPurchase: ({ commit }, payload) => {
    commit("setCurrentPurchase", payload);
  },
  setAddingUser: ({ commit }, payload) => {
    commit("setAddingUser", payload);
  },
  setSelectedClient: ({ commit }, payload) => {
    commit("setSelectedClient", payload);
  },
  setTypeOfPrice: ({ commit }, payload) => {
    commit("setTypeOfPrice", payload);
  },
  setConvocationBalance: ({ commit }, payload) => {
    commit("setConvocationBalance", payload);
  },
  setCurrentPurchaseTypeOfProduct: ({ commit }, payload) => {
    commit("setCurrentPurchaseTypeOfProduct", payload);
  },
  setCurrentBudget: ({ commit }, payload) => {
    commit("setCurrentBudget", payload);
  },
  setCurrentBudgetAcceptance: ({ commit }, payload) => {
    commit("setCurrentBudgetAcceptance", payload);
  },
  setCurrentBudgetAcceptanceDelegationList: (
    { getters, commit, dispatch },
    payload
  ) => {
    commit("setCurrentBudgetAcceptanceDelegationList", payload);
    const currentBudget = getters.getCurrentBudgetAcceptance;
    const selectedConvocations =
      getters.getCurrentBudgetAcceptanceSelectedConvocations;
    dispatch("calculateBudgetAcceptance", {
      convocation: selectedConvocations,
      budgetId: currentBudget.id,
      delegation: getters.getCurrentBudgetAcceptanceDelegationIdsList,
      feeNumber: currentBudget.numberOfFees || 1
    });
  },
  updateCurrentBudgetAcceptanceDelegationList: (
    { getters, commit, dispatch },
    payload
  ) => {
    commit("updateCurrentBudgetAcceptanceDelegationList", payload);
    commit("checkCurrentBudgetAcceptanceConvocationList");
    const currentBudget = getters.getCurrentBudgetAcceptance;
    commit("clearAcceptanceTimeout");
    const selectedConvocations =
      getters.getCurrentBudgetAcceptanceSelectedConvocations;
    const acceptanceTimeout = setTimeout(() => {
      dispatch("calculateBudgetAcceptance", {
        convocation: selectedConvocations,
        budgetId: currentBudget.id,
        delegation: getters.getCurrentBudgetAcceptanceDelegationIdsList,
        feeNumber: currentBudget.numberOfFees || 1
      });
    }, Constants.requestTimeoutTime);
    commit("setAcceptanceTimeout", acceptanceTimeout);
  },
  fetchBudgetConvocations: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.budget}${payload.id}/convocation/`)
        .then(res => {
          const data = res.data.results;
          commit("setCurrentBudgetAcceptanceConvocationList", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
          commit("setServerError", err.response.data);
        });
    });
  },
  fetchPurchaseTagList: ({ commit }) => {
    return new Promise((resolve, reject) => {
      $http
        .get(`${Endpoints.purchaseTag}`)
        .then(res => {
          commit("setPurchaseTagList", res.data.results);
          resolve(res.data.results);
        })
        .catch((err: any) => {
          reject(err);
          commit("setServerError", err.response.data);
        });
    });
  },
  setCurrentBudgetAcceptanceConvocationList: (
    { getters, commit, dispatch },
    payload
  ) => {
    commit(
      "setCurrentBudgetAcceptanceSelectedConvocations",
      payload.convocations
    );
    const currentBudget = getters.getCurrentBudgetAcceptance;
    dispatch("calculateBudgetAcceptance", {
      budgetId: currentBudget.id,
      delegation: getters.getCurrentBudgetAcceptanceDelegationIdsList,
      convocation: payload.convocations,
      convocationTouch: payload.convocationTouch,
      feeNumber: currentBudget.numberOfFees
    });
  },
  setCurrentBudgetAcceptancePreviousConvocationList: ({ commit }, payload) => {
    commit("setCurrentBudgetAcceptancePreviousSelectedConvocations", payload);
  },
  setCurrentBudgetAcceptanceProductList: ({ commit }, payload) => {
    commit("setCurrentBudgetAcceptanceProductList", payload);
  },
  updateCurrentBudgetAcceptanceProductList: ({ commit }, payload) => {
    commit("updateCurrentBudgetAcceptanceProductList", payload);
  },
  calculateBudgetAcceptance: ({ getters, commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(`${Endpoints.budget}${payload.budgetId}/acceptance/`, payload)
        .then(res => {
          const data = res.data;
          commit(
            "setCurrentBudgetAcceptanceSelectedConvocations",
            data.convocation
          );
          const currentBudget = getters.getCurrentBudgetAcceptance;
          currentBudget.numberOfFees = data.feeNumber;
          currentBudget.maxUnitFee = data.maxFeeNumber;
          commit("setBudgetFeeFromFeeList", { feeList: data.feeList });
          commit("setFeeList", data.feeList);
          commit("setCurrentBudgetAcceptance", currentBudget);
          commit("setCurrentBudgetAcceptanceMessageInfo", data.itineraryInfo);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
          commit(
            "setCurrentBudgetAcceptanceSelectedConvocations",
            getters.getCurrentBudgetAcceptancePreviousSelectedConvocations
          );
          commit("setServerError", err.response.data);
        });
    });
  },
  finishCurrentBudgetAcceptance: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(
          `${Endpoints.budget}${payload.budgetId}/acceptance/create/`,
          payload
        )
        .then(res => {
          const data = res.data;
          commit("setCurrentBudgetAcceptance", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fetchBudgetValidate: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(Endpoints.budgetValidation(payload.id))
        .then(res => {
          const data = res.data;
          data.numberOfFees = data.budgetFee.length;
          commit("setCurrentBudgetAcceptance", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  validateBudgetAcceptance: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(Endpoints.budgetValidation(payload.id))
        .then(res => {
          const data = res.data;
          resolve(data);
        })
        .catch((err: any) => {
          commit("setServerError", err.response.data);
          reject(err);
        });
    });
  },
  fetchUserMoneyFlow: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(Endpoints.userMoneyFlow(payload.id))
        .then(res => {
          const data = res.data;
          commit("setUserMoneyFlow", data.quantity);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  setUserMoneyFlow: ({ commit }, payload) => {
    commit("setUserMoneyFlow", payload);
  },
  setCurrentPurchaseLoading: ({ commit }, payload) => {
    commit("setCurrentPurchaseLoading", payload);
  },
  patchFiscalDataExtension: ({ commit, getters }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .patch(Endpoints.userFiscalDataExtension(payload.userId, payload.id), payload.data)
        .then(res => {
          const data = res.data;
          // commit("updateFiscalDataExtension", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  updateFiscalDataExtension: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .put(Endpoints.userFiscalDataExtension(payload.userId, payload.id), payload)
        .then(res => {
          const data = res.data;
          // commit("updateFiscalDataExtension", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  newFiscalDataExtension: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .post(Endpoints.newUserFiscalDataExtension(), payload)
        .then(res => {
          const data = res.data;
          // commit("newFiscalDataExtension", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
  fiscalDataList: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      $http
        .get(Endpoints.fiscalDataList(payload))
        .then(res => {
          const data = res.data;
          commit("fiscalDataList", data);
          resolve(data);
        })
        .catch((err: any) => {
          reject(err);
        });
    });
  },
};
